import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import SourceFlowTracker from "@sourceflow-uk/sourceflow-tracker";
import metaObject from "../.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import CookieConsent from "@/components/Shared/CookieConsent";
import Layout from '@/components/layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { GoogleAnalytics } from '@next/third-parties/google';
import Script from 'next/script';

import '../styles/styles.scss';

/**
 *
 * @param Component
 * @param pageProps
 * @returns {JSX.Element}
 * @constructor
 */
export default function App({ Component, pageProps }) {
	return (
		<Layout>
			<SourceFlowHead
				metaObject={metaObject}
				siteName={sourceflowEnums.seo.siteName}
				images={sourceflowEnums.seo.images}
				twitter={sourceflowEnums.seo.twitter}
				title={pageProps.meta?.title ?? sourceflowEnums.seo.titleTemplate}
				description={pageProps.meta?.description ?? null}
				canonical={pageProps.meta?.canonical ?? null}
			/>
			<Component {...pageProps} />
			<GoogleAnalytics gaId="G-JKQPS8LCP5" />
			<CookieConsent>
				<SourceFlowTracker />
			</CookieConsent>
			{/* Add HubSpot Tracking Script */}
			<Script
                id="hs-script-loader"
                strategy="lazyOnload"
                src="https://js-eu1.hs-scripts.com/145768746.js"
            />
          	{/* End of Hubspot Tracking Script */}
		</Layout >
	)
}
